<template>
  <div class="auth-loading-wrap">
    <div class="loading-box" v-loading="true" element-loading-text="正在登录中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)"></div>
  </div>
</template>

<script>
import { exchange } from "@/common/api";

export default {
  name: "auth-loading",
  created() {
    var code = this.$route.query.code;
    var redirect = this.$route.query.redirect || "/";

    if (!code) {
      this.$message.error("授权码缺失，请重新登录");
      this.$router.replace({ path: "/login" });
      return;
    }

    exchange(code)
      .then((res) => {
        if (res.code == 0) {
          localStorage.setItem("crmUserSid", res.data.sid);
          localStorage.setItem("crmUserToken", res.data.token);
          localStorage.setItem("crmUserMobile", res.data.mobile);
          localStorage.setItem("crmUserName", res.data.name);
          localStorage.setItem("agentType", res.data.agentType);
          localStorage.setItem("companyId", res.data.companyId);

          // redirect 可能是带 query 的完整路径，需要拆分
          var parts = redirect.split("?");
          var targetPath = parts[0];
          var targetQuery = {};
          if (parts[1]) {
            parts[1].split("&").forEach(function (item) {
              var pair = item.split("=");
              targetQuery[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
            });
          }
          this.$router.replace({ path: targetPath, query: targetQuery });
        } else {
          this.$message.error(res.msg || "授权登录失败");
          this.$router.replace({ path: "/login" });
        }
      })
      .catch(() => {
        this.$message.error("服务器异常");
        this.$router.replace({ path: "/login" });
      });
  },
};
</script>

<style scoped lang="scss">
.auth-loading-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.loading-box {
  width: 100%;
  height: 100%;
}
</style>
